import { SpaceType } from '@mode/shared/contract-common';
import { OrgTypes } from '@mode/shared/contract-common';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { uniqBy } from 'lodash';
import * as fromCollection from './collection.reducer';

const sidebarSort = function (a: OrgTypes.Collection, b: OrgTypes.Collection) {
  if (a.type === SpaceType.private) return -1;
  if (b.type === SpaceType.private) return 1;
  if (a.type === SpaceType.community) return -1;
  if (b.type === SpaceType.community) return 1;
  if (a.name === 'General') return -1;
  if (b.name === 'General') return 1;
  if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
  if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
  return 0;
};

export const selectCollectionState = createFeatureSelector<fromCollection.State>(fromCollection.collectionFeatureKey);

export const selectCollections = createSelector(selectCollectionState, (state) => state.collections);
// introduced in https://github.com/mode/webapp/commit/3fec32d9e23d90852646862836f21d9e766bee19
// uniqBy 'token' is used to avoid having two "org spaces" in side-nav
export const selectSidebarSortedCollections = createSelector(selectCollectionState, (state) =>
  uniqBy([...state.collections].sort(sidebarSort), 'token')
);
export const selectCollectionsComplete = createSelector(selectCollectionState, (state) => state.isCollectionsComplete);
export const selectCollectionsLoading = createSelector(selectCollectionState, (state) => state.isCollectionsLoading);
export const selectCollectionsError = createSelector(selectCollectionState, (state) => state.collectionsError);
